<template>
  <div class="account-type-lozenge" :class="{ 'expanded-mode': !compactMode }" @click="handleClick">
    <div class="lozenge-content">
      <div class="icon-container">
        <img v-if="iconUrl" :src="iconUrl" :alt="accountType" class="icon" />
      </div>
      <div class="text-content" :class="{ 'no-text': !(!compactMode && text) }">
        <p class="account-type-label">{{ accountType }}</p>
        <p v-if="!compactMode && text" class="account-type-text">
          <img v-if="textIcon" :src="textIcon" :alt="accountType" class="text-icon" />
          <span class="subText" v-html="formatText(text)"></span>
        </p>
      </div>
    </div>

    <div v-if="!isAddButton && compactMode" class="count-badge">
      {{ accountCount }}
    </div>
    <div v-else-if="isAddButton && compactMode" class="add-badge">
      <v-icon size="12" color="white">mdi-plus</v-icon>
    </div>
    <div v-else-if="!compactMode" class="arrow-badge">
       <img class="arrow" :src="require('@/assets/arrow-right.png')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountTypeLozenge',
  props: {
    accountType: {
      type: String,
      required: true,
      description: 'Type of account (e.g., "Current Account", "Savings")'
    },
    accountCount: {
      type: Number,
      default: null,
      description: 'Number of accounts of this type. If null, shows an add button instead'
    },
    iconUrl: {
      type: String,
      required: true,
      description: 'URL for the account type icon/illustration'
    },
    isAddButton: {
      type: Boolean,
      default: false,
      description: 'If true, shows a plus icon instead of a count badge'
    },
    compactMode: {
      type: Boolean,
      default: true,
      description: 'If false, uses expanded styling with larger text and right arrow'
    },
    text: {
      type: String,
      default: null,
      description: 'Optional text field to display under the label in expanded mode'
    },
    textIcon: {
      type: String,
      default: null,
      description: 'Optional icon to display before the text in expanded mode'
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', {
        accountType: this.accountType,
        isAddButton: this.isAddButton
      });
    },
    formatText(text) {
      return text.replace(/<b>/g, '<strong>').replace(/<\/b>/g, '</strong>');
    }
  }
}
</script>

<style scoped>
.subText {
  font-size: 11px;
}

.arrow {
  width: 18px;
  height: 12px;
}

.account-type-lozenge {
  background: white;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  width: 100%;
  transition: background-color 0.2s ease;
}

.account-type-lozenge.expanded-mode {
  background: #f5f5f5;
  height: 60px;
  padding: 12px;
}

.lozenge-content {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.account-type-lozenge.expanded-mode .lozenge-content {
  gap: 8px;
  align-items: flex-start;
  padding-top: 4px;
}

.account-type-lozenge.expanded-mode .lozenge-content:has(.text-content.no-text) {
  align-items: center;
  padding-top: 0;
}

.icon-container {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.account-type-lozenge.expanded-mode .icon-container {
  width: 32px;
  height: 32px;
}

.icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.account-type-label {
  font-size: 11px;
  line-height: 12px;
  color: #392a4e;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.account-type-lozenge.expanded-mode .account-type-label {
  font-size: 14px;
  line-height: 16px;
  white-space: normal;
}

.text-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

.text-content.no-text {
  justify-content: center;
}

.account-type-text {
  font-size: 12px;
  line-height: 14px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.text-icon {
  width: 14px;
  height: 8px;
  flex-shrink: 0;
}

.count-badge {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #413655;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 9px;
  line-height: 12px;
  color: white;
  text-align: center;
}

.add-badge {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: rgba(65, 54, 85, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.arrow-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>
